const production = true;

export const environment = {
  production,
  pinHost: '/pin',
  standardHost: '/standard',
  structuresHost: '/structures-adapter',
  tooltipDelay: 500,
  snackbarDuration: 5000,
  maxAttachmentSizeBytes: 100000000,
  tsesConfig: {
    production,
    apiHost: '/api',
    debounceTime: 500,
    undoSize: 128,
    typeButtonsName: 'Style',
    typeButtonsTooltip: 'Change text style',
    allowLandscapeFragments: false,
    otherUrlsToAuthenticate: ['/standard', '/pin', '/structures-adapter'],
  },
  datetime: {
    defaultDateFormat: 'DD/MM/YYYY',
    defaultTimeFormat: 'HH:mm',
  },
};
